<template>
  <GeneralForm :jenisJurnal="8" :title="title" :routeBack="routeBack" :jurnalUrl="url" />
</template>

<script>
import GeneralForm from '@/views/jurnal/GeneralForm.vue';

export default {
    components: {
        GeneralForm
    },
    data:() => ({
       title : 'Jurnal Aktiva',
       url : '/api/ju',
       routeBack : 'jraktivalist',
    }),
    methods: {
       
    }
}
</script>


<style>

</style>